'use client';
import * as avatar from '@zag-js/avatar';
import { useMachine, normalizeProps } from '@zag-js/react';
import { useId } from 'react';
import { useEnvironmentContext } from '../environment/environment-context.mjs';
import { useEvent } from '../use-event.mjs';

const useAvatar = (props = {}) => {
  const initialContext = {
    id: useId(),
    getRootNode: useEnvironmentContext(),
    ...props
  };
  const context = {
    ...initialContext,
    onLoadingStatusChange: useEvent(props.onLoadingStatusChange)
  };
  const [state, send] = useMachine(avatar.machine(initialContext), { context });
  return avatar.connect(state, send, normalizeProps);
};

export { useAvatar };
